module.exports = __webpack_public_path__ + "img/model15_zh.b3f6f3f9.jpg";